import React, { useContext } from "react";
import { Editor } from "@tinymce/tinymce-react";
import UserContext from "../contexts/UserContext";

const TextEditor = (props) => {
  const { setServerData } = useContext(UserContext);
  const onImageUpload = (blobInfo, success, failure, progress) => {
    var formData = new FormData();
    formData.append("file", blobInfo.blob(), blobInfo.filename());

    setServerData("editorimages", formData, "post")
      .then((res) => success(res.data.location))
      .catch((e) => failure(e.message));
  };

  return (
    <Editor
      apiKey={process.env.TINYMCE_API_KEY}
      value={props.value}
      onInit={props.onInit}
      init={{
        selector: "textarea#open-source-plugins",
        plugins:
          "fontawesomepicker print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons",
        imagetools_cors_hosts: ["picsum.photos"],
        menubar: "file edit view insert format tools table help",
        toolbar:
          "fontawesomepicker | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
        external_plugins: {
          fontawesomepicker: "https://www.unpkg.com/tinymce-fontawesomepicker/fontawesomepicker/plugin.min.js",
          // fontawesomepicker: '/tinymce-fontawesomepicker/fontawesomepicker/plugin.js'
        },
        fontawesomeUrl: "https://www.unpkg.com/@fortawesome/fontawesome-free@5.14.0/css/all.min.css",
        toolbar_sticky: true,
        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_prefix: "{path}{query}-{id}-",
        autosave_restore_when_empty: false,
        autosave_retention: "2m",
        importcss_append: true,
        extended_valid_elements: 'script[language|type|src]',
        valid_children: "+body[style]",
        block_unsupported_drop: false,
        images_upload_handler: onImageUpload,
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
          },
          { title: "Starting my story", description: "A cure for writers block", content: "Once upon a time..." },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
          },
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        height: 300,
        image_caption: true,
        quickbars_selection_toolbar: "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",
        contextmenu: "link image imagetools table",

        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
      }}
      onEditorChange={props.onChange}
    />
  );
};

export default TextEditor;
